import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row gx-8 gx-lg-0 product__recomendations" }
const _hoisted_2 = { class: "col col-12 category__title-heading" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { class: "row g-5 g-md-4 product-listings" }

import { onMounted, ref } from "vue";
import dictionary from "@/i18n/dictionary.json";
import { ProductApi } from "@/services/Api";
import TressProductTile from "@/components/TressProductTile.vue";
import { ProductTile } from "@/models/ProductList";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressProductRecommendations',
  props: {
  productId: {
    type: String,
    required: true,
  },
  showAsB2b: {
    type: Boolean,
    required: true,
  },
  site: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const products = ref(Array<ProductTile>());

onMounted(async () => {
  try {
    products.value = await ProductApi.productRecommendations(props.productId);
  } catch (error: unknown) {
    console.error(error);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", {
        textContent: _toDisplayString(_ctx.$t(_unref(dictionary).producttile.heading.recommendations))
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: product.id,
          class: "col col-6 col-md-4 col-xl-3 col-xxl-2-4 product-listings__container"
        }, [
          _createVNode(TressProductTile, {
            content: product,
            index: idx,
            "show-as-b2b": __props.showAsB2b,
            site: __props.site
          }, null, 8, ["content", "index", "show-as-b2b", "site"])
        ]))
      }), 128))
    ])
  ]))
}
}

})